import React, { useState, useEffect } from "react";
import {
  getImageDimensions,
  isVideo
} from "../../../../SelfServiceCampaignCreation/Previews/utils";

// Browser detection utility
const isChrome = () => {
  if (typeof window === "undefined") return false;
  const userAgent = window.navigator.userAgent;
  return /Chrome/.test(userAgent) && !/Edg/.test(userAgent);
};

export const SlideAsset = ({ asset, assetHeight = 72 }) => {
  const [dimensions, setDimensions] = useState(null);
  const needsWidthCalculation = !isChrome();

  useEffect(() => {
    // Only load dimensions if we need width calculation (non-Chrome browsers)
    if (!needsWidthCalculation) return;

    const loadDimensions = async () => {
      try {
        const dims = await getImageDimensions(asset);
        setDimensions(dims);
      } catch (error) {
        console.error("Failed to load dimensions:", error);
      }
    };

    loadDimensions();
  }, [asset, needsWidthCalculation]);

  const getCalculatedWidth = () => {
    if (!needsWidthCalculation) return "auto";
    if (!dimensions?.ar) return "auto";
    return `${assetHeight * dimensions.ar}px`;
  };

  const commonStyles = {
    height: "100%",
    objectFit: "cover",
    borderRadius: "inherit",
    width: getCalculatedWidth()
  };

  if (isVideo(asset)) {
    return <video src={asset} autoPlay muted loop style={commonStyles} />;
  }

  return <img src={asset} alt="media preview" style={commonStyles} />;
};
